import React from "react";
import ClientListCompoent from "../../components/manager/users/clients/ClientListCompoent";
// import { useDispatch, useSelector } from "react-redux";
// import { getAllUsersAction } from "../../services/action/manager";
import DashboardLayout from "../../components/layouts/DashboardLayout";
const ClientListSA = () => {
  // const dispatch = useDispatch();
  // const { userList } = useSelector((state) => state.managerReducer);

  // const [pageData, setPageData] = useState({
  //   page: 1,
  //   limit: 15,
  // });
  // const [search, setSearch] = useState("");
  // const [isWhatsAppClient,setIsWhatsAppClient]=useState(false)

  // const getList = ({ limit=pageData.limit,currentPage, firstTime = true, keyword = search,tempIsWhatsAppClient=isWhatsAppClient }) => {
  //   dispatch(
  //     getAllUsersAction({
  //       userType: "super_admin",
  //       firstTime,
  //       data: { userType: "client", page: currentPage,limit, keyword ,isWhatsAppClient:!!tempIsWhatsAppClient},
  //     })
  //   );
  // };
  // useEffect(() => {
  //   getList({ currentPage: 1, firstTime: true });
  // }, []);

  return (
    <DashboardLayout
    // onSearch={(e) => {
    //   setPageData({ page: 1 });
    //   setSearch(e);
    //   getList({ currentPage: 1, firstTime: true, keyword: e });
    // }}
    >
      <ClientListCompoent
        listType="CLIENT"
        // getList={getList}
        // TeamsData={userList}
        // setPageData={setPageData}
        // pageData={pageData}
        // setIsWhatsAppClient={setIsWhatsAppClient}
        // isWhatsAppClient={isWhatsAppClient}
      />
    </DashboardLayout>
  );
};

export default ClientListSA;
